import {
  MrSearchConfig,
  MrSearchFacetsConfig,
  MrSearchLayoutInput,
} from '@net7/boilerplate-muruca';

const facets = {
  redirectLink: {
    label: 'search#redirect_link',
    paths: {
      it: '/busqueda-avanzada',
      en: 'en/research',
    },
  },
  sections: [
    {
      id: 'section-query',
      inputs: [
        {
          id: 'query',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query',
            placeholder: 'search#placeholder_query',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    }, 
    {
      id: 'section-autoria',
      header: {
        id: 'header-autoria',
        data: {
          text: 'search#header_autoria',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'autoria',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-refundiciones',
      header: {
        id: 'header-refundiciones',
        data: {
          text: 'search#header_refundiciones',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'refundiciones',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-universo',
      header: {
        id: 'header-universo',
        data: {
          text: 'search#header_universo',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'universo',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-duracion',
      header: {
        id: 'header-duracion',
        data: {
          text: 'search#header_duracion',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'duracion',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
  ],
  classes: 'facets-wrapper',
} as MrSearchFacetsConfig;

const layoutInputs = ['page', 'limit', 'sort'].map((id) => ({
  id,
  queryParam: true,
  schema: {
    valueType: id === 'sort' ? 'string' : 'number',
  },
})) as MrSearchLayoutInput[];

const request = {
  results: {
    id: 'search',
    delay: 500,
  },
  facets: {
    id: 'facets',
  },
  provider: 'rest',
  delay: 500,
};

export default { request, facets, layoutInputs } as MrSearchConfig;
